<template>
  <div class="relative inline-block focus:outline-none focus:ring-4 focus:ring-primary focus:ring-opacity-40">
    <a
      v-if="!isComingSoon"
      :href="localizedURL"
      target="_blank"
      rel="noopener"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 81 24"
        role="presentation"
        class="inline-block -mb-0.5 align-baseline"
      >
        <g>
          <component :is="iconComponent" />
        </g>
      </svg>
    </a>
    <div v-else class="inline-block">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 81 24"
        role="presentation"
        class="inline-block -mb-0.5 align-baseline opacity-50"
      >
        <g>
          <component :is="iconComponent" />
        </g>
      </svg>
      <div class="absolute inset-0 flex items-center justify-center bg-secondary/85 rounded-md text-white font-semibold mb-1 text-container">
        COMING SOON
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import * as badges from './badges/index';

const props = defineProps({
  iconName: {
    type: String,
    default: ''
  },
  iconType: {
    type: String,
    default: () => null
  },
  isComingSoon: {
    type: Boolean,
    default: false
  }
});

const iconComponent = badges[props.iconType]

const localizedURL = computed(() => {
  switch (props.iconType) {
    case 'android_de':
      return 'http://play.google.com/store/apps/details?id=com.beyondbreath.androidapp&hl=de';
    case 'android_en':
      return 'http://play.google.com/store/apps/details?id=com.beyondbreath.androidapp&hl=en';
    case 'ios_de':
      return 'https://itunes.apple.com/de/app/id6498632607';
    case 'ios_en':
      return 'http://itunes.apple.com/app/id6498632607';
    default:
      return 'http://play.google.com/store/apps/details?id=com.beyondbreath.androidapp&hl=de';
  }
});
</script>

<style scoped>
.text-container{font-size:calc(100% - 6px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
</style>
